import { ScrollArea } from '@/components/ui/scroll-area';

import type { PresetRange } from '../../lib/date-utils';
import { PresetButton } from './preset-button';

interface PresetSidebarProps {
  presetRanges: PresetRange[];
  selectedPreset: string | null;
  onPresetSelect: (presetId: string) => void;
}

export function PresetSidebar({ presetRanges, selectedPreset, onPresetSelect }: PresetSidebarProps) {
  return (
    <ScrollArea className="h-auto sm:h-[350px] w-full sm:w-[180px] border-b sm:border-b-0 sm:border-r bg-muted/30">
      <div className="p-2 flex flex-row sm:flex-col gap-2 overflow-x-auto sm:overflow-x-visible">
        {presetRanges.map((preset) => (
          <PresetButton
            key={preset.id}
            preset={preset}
            isSelected={selectedPreset === preset.id}
            onSelect={() => onPresetSelect(preset.id)}
          />
        ))}
      </div>
    </ScrollArea>
  );
}
